import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { EstacionesState } from '@/store/modules/estaciones/types'
import { getters } from '@/store/modules/estaciones/getters'
import { actions } from '@/store/modules/estaciones/actions'
import { mutations } from '@/store/modules/estaciones/mutations'

export const state: EstacionesState = {
  grupoTipoVariable: [],
  tipoVariable: {
    estacion_list: [],
    tipo_variable_list: []
  },
  estaciones: {
    estacion_list: []
  },
  dataEstacion: [],
  error: { state: false }
}

const namespaced: boolean = true

export const estaciones: Module<EstacionesState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
